// extracted by mini-css-extract-plugin
export default {"linkButtonWrapper":"up-arrow_linkButtonWrapper__ZxEPb","linkButton":"up-arrow_linkButton__YYFsv","arrowWrapper":"up-arrow_arrowWrapper__6RxzK"};